<template>
  <Screen
    branded-header
    center-transparent
  >
    <div
      slot="screen-center"
      class="faq"
    >
      <section class="faq__content">
        <h1 class="faq__heading">
          Frequently Asked Questions ℹ
        </h1>
        <p class="faq__intro">
          Advice and answers from the team at Stitch
        </p>

        <div
          v-for="(faq, faqIndex) in faqs"
          :key="faqIndex"
        >
          <div
            v-for="(section, sectionIndex) in faq"
            :key="sectionIndex"
            class="faq__section"
          >
            <h1
              class="faq__section-title"
              @click="expandSection(section.title)"
            >
              {{ section.title }}
            </h1>

            <div
              :class="[
                'faq__section-container',
                {
                  'faq__section-container--active':
                    activeTab === section.title || true
                }
              ]"
            >
              <section
                v-for="(question, questionIndex) in section.questions"
                :key="questionIndex"
              >
                <h2
                  class="faq__section-question"
                  @click="expandQuestion(question.question)"
                >
                  {{ question.question }}
                </h2>
                <p
                  :class="[
                    'faq__section-answer',
                    {
                      'faq__section-answer--active':
                        activeAnswer === question.question
                    }
                  ]"
                  v-html="question.answer"
                />
              </section>
            </div>
          </div>
        </div>
        <p>
          <small>
            Get in touch with our
            <a
              href="mailto:3DSupport@pvh.com?Subject=Hello%20again"
              target="_blank"
            >3D Support Team</a>
          </small>
        </p>
      </section>
    </div>
  </Screen>
</template>

<script>
import Screen from '@/components/Screen.vue'
import faqs from '@/resources/faq.json'

export default {
  name: 'Faq',

  components: {
    Screen
  },

  data: () => ({
    faqs: faqs,
    activeTab: null,
    activeAnswer: null
  }),

  methods: {
    /**
     * @param {string} section
     */
    expandSection (section) {
      this.activeTab = section
    },

    /**
     * @param {object} question
     */
    expandQuestion (question) {
      this.activeAnswer = question
    }
  }
}
</script>

<style lang="scss" scoped>
.faq {
  height: 100%;

  a {
    color: $blue;
  }
}

.faq__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: $spacer-unit;
}

.faq__heading {
  font-size: $font-size-extra-large;
}

.faq__section {
  margin-bottom: $spacer-unit;
  padding: $spacer-unit;
  background-color: $white;
  border-radius: $border-radius-default;
  box-shadow: $shadow-default;
}

.faq__section-container,
.faq__section-question,
.faq__section-answer {
  padding: $spacer-unit;
}

.faq__section-container,
.faq__section-answer {
  display: none;
  margin: 0;

  &--active {
    display: block;
  }
}

.faq__section-title,
.faq__section-question {
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: $blue;
  }
}
</style>
